<div class="container">
    <div class="title">{{data.title |translate}}</div> <br />
    <div class="subtitle">{{data.subtitle1 |translate }} </div><br />
    <div class="body">{{data.label1 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle2 |translate }} </div><br />
    <div class="body">{{data.label2 |translate }}</div>
    <br />
    <div class="subtitle">{{data.subtitle3 |translate }} </div><br />
    <div class="body">{{data.label3 |translate }}</div>
    <br />
</div>
<div class="button-bar">
    <div class="button" (click)="onNoClick()">retour</div>
</div>